import React from "react";
import { Button, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ModulePageShell from "../components/common/ModulePageShell";
import OperationalPanel from "../components/common/OperationalPanel";
import PerformanceLocalNav from "../components/common/PerformanceLocalNav";
import StatusBadge from "../components/common/StatusBadge";
import { CompactEmptyState } from "../components/common/PageState";
import { formatDateTime } from "../utils/normalize";

const PerformanceImportsPage = () => {
  const navigate = useNavigate();
  const rows = [];

  return (
    <ModulePageShell
      title="Template imports"
      description="Track Excel imports that create PMS draft templates."
      actions={<Button size="sm" colorScheme="blue" onClick={() => navigate("/performance/pms-format/templates/import")}>Import Excel</Button>}
    >
      <PerformanceLocalNav />
      <OperationalPanel>
        {rows.length === 0 ? (
          <CompactEmptyState title="No template imports found." message="Upload an Excel workbook to start an import." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>File name</Th>
                  <Th>Imported on</Th>
                  <Th>Status</Th>
                  <Th>Imported by</Th>
                  <Th>Template created</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {rows.map((row) => (
                  <Tr key={row._id || row.id}>
                    <Td>{row.fileName}</Td>
                    <Td>{formatDateTime(row.createdAt)}</Td>
                    <Td><StatusBadge value={row.status} /></Td>
                    <Td>{row.importedBy?.name || "-"}</Td>
                    <Td>{row.templateId?.name || "-"}</Td>
                    <Td><Button size="xs" variant="outline">View</Button></Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </OperationalPanel>
    </ModulePageShell>
  );
};

export default PerformanceImportsPage;
